import { SharedTranslationModule } from '@tcc-mono/shared/translation';
import { getAppConfigProvider } from '@tcc-mono/shared/app-config';
import { VanDijkWebShellModule } from '@tcc-mono/vandijk/web/shell/feature';
import { DEFAULT_CURRENCY_CODE, NgModule } from '@angular/core';
import localeNl from '@angular/common/locales/nl';
import { LOCALE_ID } from '@angular/core';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

registerLocaleData(localeNl);
@NgModule({
  declarations: [AppComponent],
  imports: [
    IonicModule.forRoot({
      innerHTMLTemplatesEnabled: true
    }),
    VanDijkWebShellModule,
    HttpClientModule,
    SharedTranslationModule.forRoot(environment)
  ],
  providers: [
    getAppConfigProvider(environment),
    { provide: LOCALE_ID, useValue: 'nl'},
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
